import { createStore } from "@stencil/store";

export interface FeatureToggleState {
  features: FeatureMap;
}

export interface FeatureMap {
  [featureName: string]: { enabled: boolean };
}

export const featureTogglesDefaultData = {
  features: {},
};

export const featureToggleStateStore = createStore<FeatureToggleState>({
  features: {},
});
